/**
 * feedbackItem.jsx
 *
 * @Author: apple
 * @Date: 2018/4/13 01:07
 */

import React from 'react';
import PropTypes from 'prop-types';
import {Tag, Collapse, Input, Button, Notice, Modal, Icon} from 'neatui';
import moment from 'moment';
import nosConfig from 'Util/nosConfig';
import ajax from "../util/ajax";
import getBlen from '../../util/getBlen';
import './style.module.scss';

const PREFIX_TEST_URL = `//${
  /pre|mp/.test(window.location.host) ? 'newsfeedback.ws.netease.com' : 't.c.m.163.com'
}/uc/feedback/admin/mp`;

class FeedbackItem extends React.PureComponent {
  static propTypes = {};

  static defaultProps = {};

  constructor(props, context) {
    super(props, context);
    this.state = {
      displayContent: false,
      replyList: [],
      fileInfo: {},
      uploadLoading: false,
      error: null,
    };
    this.fileInputRef = React.createRef();
  }

  componentWillReceiveProps(nextProps, nextStates) {
    const { id, toggleDialog } = this.props;
    const { displayContent } = this.state;
    if (nextProps.readyToCloseId && nextProps.readyToCloseId !== id && displayContent) {
      this.onToggleDetail();
    } else if (nextProps.readyToCloseId === id) {
      toggleDialog(id);
    }
  }

  onToggleDetail = () => {
    const { displayContent } = this.state;
    const { toggleDialog, id } = this.props;
    if (!displayContent) {
      toggleDialog(id);
      const getDetailList = Promise.resolve(this.getDetailList);
      getDetailList
        .then(func => {
          func();
        })
        .then(() => {
          this.setState({
            displayContent: true,
          });
        });
    } else {
      this.setState({
        displayContent: false,
      });
    }
  };

  getDetailList = () => {
    const { id } = this.props;
    const data = {
      feedbackId: id,
    };
    ajax(
      '/feedback/getReplyList.do',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data,
      },
      rs => {
        this.setState({
          replyList: rs.data,
        });
      },
    );
  };

  onHandleForm = () => {
    const { id } = this.props;
    const replyContent = this.question.state.value;
    const { fileInfo } = this.state
    const formNotice = Notice.create({
      position: 'top',
    });
    if (getBlen(replyContent) > 500) {
      formNotice.show({
        content: `追问内容长度大于500！`,
        type: 'error',
        mini: true,
      });
      return;
    }
    if (replyContent) {
      const data = {
        ids: id,
        replyContent
      };
      const { type } = fileInfo;
      if (type === 'image') {
        data.replyImg = fileInfo.url;
      }
      if (type === 'video') {
        data.replyVideo = fileInfo.url;
      }
      if (type === 'doc') {
        data.replyFile = fileInfo.url;
      }
      ajax(
        '/feedback/reply.do',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          data,
        },
        res => {
          this.question.state.value = '';
          this.getDetailList();
          this.fileInputRef.value = '';
          this.setState({
            fileInfo: {},
          })
        },
      );
    } else {
      formNotice.show({
        content: `追问信息不能为空！`,
        type: 'error',
        mini: true,
      });
    }
  };

  onUploadImage = files => {
    this.setState({
      uploadLoading: true,
    });
    const keyMap = files.map(file => ({
      key: file.name + parseInt(Math.random() * 100, 10),
      file,
    }));
    keyMap.forEach(file => {
      const formData = new window.FormData();
      formData.append('file', file.file);
      formData.append('from', nosConfig.from);
      const xhr = new window.XMLHttpRequest();
      xhr.open('POST', `//${nosConfig.domain}/api/v3/upload/picupload`);
      xhr.onload = () => {
        this.setState({
          uploadLoading: false,
        });
        let result = {};
        if (xhr.status === 200) {
          result = JSON.parse(xhr.responseText);
        }
        if (result.data) {
          const { fileInfo } = this.state;
          this.setState({
            fileInfo: {
              ...fileInfo,
              url: result.data.url,
            },
          });
        }
      };
      xhr.onerror = () => {
        this.setState({
          uploadLoading: false,
          error: '上传失败',
        });
      };
      xhr.send(formData);
    });
  };

  onUploadFile = file => {
    this.setState({
      uploadLoading: true,
    });
    const formData = new FormData();
    formData.append('file', file);
    const xhr = new window.XMLHttpRequest();
    xhr.open('POST', `//upfile.m.163.com/nos/upload/pub/aes?requireHttps=true`);
    xhr.onload = () => {
      this.setState({
        uploadLoading: false,
      });
      let result = {};
      if (xhr.status === 200) {
        result = JSON.parse(xhr.responseText);
      }
      if (result.status === 1) {
        const { fileInfo } = this.state;
        this.setState({
          fileInfo: {
            ...fileInfo,
            url: result.url,
          },
        });
      }
    };
    xhr.onerror = () => {
      this.setState({
        uploadLoading: false,
        error: '上传失败',
      });
    };
    xhr.send(formData);
  };

  handleChangeFile = events => {
    const { files } = events.target;
    if (!files.length)  return false;
    const filename = files[0].name;
    const imgReg = /(gif|png|jpe?g)$/;
    const docReg = /(doc|docx|pdf|xls|xlsx)/i;
    const videoReg = /(wmv|asf|asx|rm|rmvb|mp4|mpg|mpeg|3gp|3g2|mov|m4v|avi|dat|mkv|flv|vob|f4v|swf|mpeg4|ts)/i;
    const type = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
    if (!videoReg.test(type) && !imgReg.test(type) && !docReg.test(type)) {
      return Modal.warning({
        title: '提示',
        content: '上传材料有误，仅支持上传图片、视频、文件',
      });
    }
    if (imgReg.test(type) && files[0].size > 5000000) {
      Modal.warning({
        title: '提示',
        content: `${files[0].name || ''}文件大于5M！`,
      });
      return false;
    }
    if(videoReg.test(type) && files[0].size / 1024 > 1024 * 10){
      return Modal.warning({
        title: '提示',
        content: '视频最大不能超过10M',
      });
    }
    if(docReg.test(type) && files[0].size / 1024 > 1024 * 10){
      return Modal.warning({
        title: '提示',
        content: '文件最大不能超过10M',
      });
    }
    const { fileInfo } = this.state;
    this.setState({
      fileInfo: {
        ...fileInfo,
        fileName: filename,
        type: imgReg.test(type) ? 'image' : videoReg.test(type) ? 'video' : 'doc',
      },
    });

    if (imgReg.test(type)) {
      this.onUploadImage(Array.from(files));
    } else {
      this.onUploadFile(files[0]);
    }
  };

  handleClearFile = () => {
    this.fileInputRef.value = '';
    this.setState({
      fileInfo: {},
      error: '',
    });
  };

  handleOpenFileClick = () => {
    if (this.fileInputRef) {
      this.fileInputRef.click();
    }
  };

  renderConvertContent = content => content ? content.split('linkPrefix:')[0] : '';

  render() {
    const { content, id, feedbackTime, unreadState, opStatus, userImg, endStatus } = this.props;
    const { displayContent, replyList, fileInfo, uploadLoading, error } = this.state;
    const tagProps = {
      color: '#009A20',
      text: '已回复',
    };
    if (opStatus === 0) {
      tagProps.color = '#D1171A';
      tagProps.text = '未回复';
    }
    if (endStatus) {
      tagProps.color = '#3db1ef';
      tagProps.text = '已结束';
    }
    return (
      <li styleName="li" key={id}>
        <div styleName="question" onClick={this.onToggleDetail}>
          <div styleName="question-left">
            <Tag color={tagProps.color} styleName="tag">
              {tagProps.text}
            </Tag>
            <div styleName="question-left-content">
              <p>{this.renderConvertContent(content)}</p>
              {unreadState ? <span styleName="circle" /> : null}
            </div>
          </div>
          <div styleName="question-right">{moment(feedbackTime).format('YYYY-MM-DD HH:mm')}</div>
        </div>
        <Collapse in={displayContent}>
          {!!replyList.length && (
            <ul styleName="reply-list">
              {replyList.map(item => {
                const { replyImg, replyContent, replyTime, replyAdminUserName, type } = item;
                let headerIcon =
                  userImg || '//static.ws.126.net/utf8/mp/static/media/customerHead.png';
                let name = '我';
                if (type === 1) {
                  headerIcon = '//static.ws.126.net/utf8/bjzw/neteaseHeader.png';
                  name = '网易号客服';
                }
                return (
                  <li styleName="reply-li">
                    <div styleName="left">
                      <img styleName="user-img" src={headerIcon} />
                      <div styleName="reply-user-info">
                        <p styleName="reply-user-name">{name || replyAdminUserName}</p>
                        <p styleName="reply-user-content">{replyContent}</p>
                      </div>
                    </div>
                    <div styleName="right">{replyTime}</div>
                  </li>
                );
              })}
            </ul>
          )}
          {!!replyList.length && !endStatus ? (
            <div styleName="form">
              <div>
                <Input
                  type="textarea"
                  ref={question => (this.question = question)}
                  multiline
                  rows={5}
                  style={{ width: 695, minHeight: 206, marginBottom: 20 }}/>
              </div>
               <div styleName="form-upload">
                <div styleName="form-upload-content">
                  <input
                    disabled={!!fileInfo.fileName}
                    accept="image/*,video/mkv,video/mov,video/flv,video/mpeg4,video/rm,video/rmvb,video/wmv,video/ts,video/asf,video/vob,video/dat,video/m4v,video/3gp,video/mp4,video/avi,video/quicktime,.docx,application/pdf,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    type="file"
                    style={{ cursor: fileInfo.fileName ? 'not-allowed' : 'pointer' }}
                    ref={el => (this.fileInputRef = el)}
                    onChange={this.handleChangeFile}/>
                  <span onClick={this.handleOpenFileClick} style={{ cursor: fileInfo.fileName ? 'not-allowed' : 'pointer', opacity: fileInfo.fileName ? '0.4' : '1' }}>添加文件</span>
                </div>
                <span>每次仅可添加一个文件（支持图片、视频、文档）</span>
               </div>
              {fileInfo && fileInfo.fileName ? (
                <div styleName="file-name">
                  {uploadLoading ? '上传中' : !error && fileInfo.fileName && (
                    <>
                      <span>{fileInfo.fileName}</span>
                      <span styleName="file-name-clear">
                        <Icon role="none" onClick={this.handleClearFile} type="cancel" />
                      </span>
                    </>
                  )}
                  {error ? (
                    <>
                      <span>{`${fileInfo.fileName}上传失败`}</span>
                      <span styleName="file-name-clear">
                        <Icon role="none" onClick={this.handleClearFile} type="cancel" />
                      </span>
                    </>
                  ) : null}
                </div>
              ) : null}
              <Button type="primary" style={{ width: 140, height: 40 }} onClick={this.onHandleForm}>
                追问
              </Button>
            </div>
          ) : !endStatus && (
            <div styleName="default-answer">暂未回复，预计1-3个工作日内回复，请您耐心等待~</div>
          )}
        </Collapse>
      </li>
    );
  }
}

export default FeedbackItem;
